import { useMarkAppointmentAsNoShowMutation } from "../../../../../../../api/appointments/useMarkAppointmentAsNoShowMutation";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";

export function useMarkNoShow() {
  const { appointment } = useContext();

  const { mutateAsync, isLoading } = useMarkAppointmentAsNoShowMutation({
    onError: () => {
      uiNotification.error(
        "Failed to mark appointment as no-show. Please try again later.",
      );
    },
    onSuccess: () => {
      uiNotification.success(
        "Appointment has been successfully marked as no-show.",
      );
    },
  });

  return {
    initiate: ({ charge }) => {
      return mutateAsync({ appointmentId: appointment.id, charge });
    },
    isLoading,
  };
}
